<script>
import { mapState ,mapActions } from "vuex";
import Loading from "@/components/layout/Loading.vue";
import AlbumesList from "@/components/intranet/galerias/AlbumesList.vue";
import IconGalerias from "@/assets/img/icon/section/IconGalerias.vue";

export default {
  name: "GaleriaAlbumes",
  components: { 
    AlbumesList,
    Loading,
    IconGalerias
  },
  data() {
      return {
          selectedYear: this.$route.params.year,
          selectedMonth: this.$route.params.month,
          cantidadAlbumes: 0,
          show_spinner: false,
          loadingGaleria: true,

        //FF
        filter: {
          search: "",
          year: ""
        },
        current: {
          year: "",
          month: "",
        },
        selected: {
          year: "",
          month: "",
        },
        heightWindow: 0,
        delay: false
      };
  },
  async created(){
    this.currentDate();
    await this.getYearAlbum();
    await this.actualYear(); 
    await this.getGaleriaMonthYear();
  },
  mounted() {
    this.windowsHeight();
    window.addEventListener('resize', this.windowsHeight);
    setTimeout(() => { this.delay = true }, 1000);

  },
  updated() {
    this.currentDate();
    this.getGaleriaMonthYear();
  },
  computed: {
    ...mapState("GaleriaModule", ["yearGaleria", "galeriasMesYear"]),
  },
  watch:{
    "filter.year"(value) {
      if(this.delay) {
          this.$router.push(`/galeria/${value.year}/${this.selected.month}`);
          this.getGaleriaMonthYear();
        }
    }
  },
  methods: {
    ...mapActions("GaleriaModule", ["getYearGaleria", "getGaleriaMesYear"]),
      toMonthName(monthNumber) {
          const date = new Date();
          date.setMonth(parseInt(monthNumber) - 1);
          return date.toLocaleString("es-CL", { month: "long" }).replace(/\./, "");
      },
      toMonthNameShort(dateParam) {
          const date = new Date(dateParam);
          date.setDate(date.getDate() + 1);
          return date.toLocaleString("es-CL", { month: "short" }).replace(/\./, "");
      },
      toDayNumber(dateParam) {
          const date = new Date(dateParam);
          date.setDate(date.getDate() + 1);
          return date.toLocaleString("es-CL", { day: "numeric"}).replace(/\./, "");
      },
      async getYearAlbum(){
        let data_ = {
          id_empresa: this.$ls.get("user").id_empresa_fk,
          id_usuario: this.$ls.get("user").id_usuario
        }
        //console.log("años: ", data_);
        this.loadingGaleria = true;
        await this.getYearGaleria(data_);
        this.loadingGaleria = false;
        //console.log("años: ", this.yearGaleria);
      },
      async getGaleriaMonthYear(){
        let data_ = {
          id_empresa: this.$ls.get("user").id_empresa_fk,
          id_usuario: this.$ls.get("user").id_usuario, 
          year: this.selected.year,
          month: this.selected.month
        }
        this.cantidadAlbumes = 10;
        await this.getGaleriaMesYear(data_);
      },

      //FF
      next() {
        let year = parseInt(this.selected.year);
        let month = parseInt(this.selected.month) + 1;
        if (month > 12) month = 1, year++
        this.$router.push(`/galeria/${year}/${month}`);
        this.selected.year = JSON.stringify(year);
        this.selected.month = JSON.stringify(month);
        this.getGaleriaMonthYear();
      },
      prev() {
        let year = parseInt(this.selected.year);
        let month = parseInt(this.selected.month) - 1;
        if (month < 1) month = 12, year--
        this.$router.push(`/galeria/${year}/${month}`);
        this.selected.year = JSON.stringify(year);
        this.selected.month = JSON.stringify(month);
        this.getGaleriaMonthYear();
      },
      async actualYear() {
        let max = Math.max.apply(Math, this.yearGaleria.map(e => e.year));
        return this.filter.year = { year: JSON.stringify(max) };
      },
      windowsHeight() {
        let mediaQuery = window.matchMedia('(min-width: 992px)');
        let height = window.innerHeight;
        if (mediaQuery.matches) this.heightWindow = height -480 + "px";
        else this.heightWindow = "auto";
			},
      currentDate() {
        let date = new Date();
        this.current.year = date.getFullYear();
        this.current.month = date.getMonth();
        this.selected.year = this.$route.params.year;
        this.selected.month = this.$route.params.month;
      }
  },
};
</script>

<template>
  <section id="galeria-albunes">

    <div class="row">
      <div class="col-12 pt-3 mb-0">
        <h1 class="h1-custom font-700 mb-1 text-capitalize color-main d-flex align-items-center">
          <IconGalerias class="me-2 icon-svg-45"/>
        {{ toMonthName($route.params.month) }}
        </h1>

        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link 
                to="/home"
                class="color-main"
              >
                <font-awesome-icon icon="fa-solid fa-house"></font-awesome-icon>
                Inicio
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link 
                to="/galeria"
                class="color-main"
              >
                <font-awesome-icon icon="fa-solid fa-images"></font-awesome-icon>
                Galerías
              </router-link>
            </li>
            <li class="breadcrumb-item text-capitalize active">
              {{ toMonthName($route.params.month) }}
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="row d-flex mt-2">
      <div class="col-12 mb-3 mb-lg-0">
        <p class="text-secondary h5-custom mb-0">
          ¡Revive nuestros mejores momentos! Descarga y dale like a tus fotos favoritas
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="border-bottom mb-3 pb-3"></div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-12 col-lg-3 input-display input-display-left mb-3 m-lg-0">
        <input 
          type="search" 
          class="form-control input-filter" 
          placeholder="Buscar"
          v-model="filter.search"
        >
        <font-awesome-icon icon="fa-solid fa-magnifying-glass" class="input-display-icon color-gray"></font-awesome-icon>
      </div>
      <div class="col-12 col-lg-6 mb-3 mb-lg-0 d-flex align-items-center justify-content-between">
        <a 
            href="javascript:" 
            @click="prev()" 
            class="h3 mb-0 color-main"
          >
          <font-awesome-icon icon="fa-solid fa-angle-left"></font-awesome-icon>
        </a>
        <h2 class="font-700 text-capitalize color-main">
          {{ toMonthName($route.params.month) }}
        </h2>
        <a 
          href="javascript:" 
          @click="next()" 
          class="h3 mb-0 color-main"
        >
        <font-awesome-icon icon="fa-solid fa-angle-right"></font-awesome-icon>
        <font-awesome-icon icon="fa-solid fa-angle-right" ></font-awesome-icon>
        </a>
      </div>
      <div class="col-12 col-lg-3">
        <v-select
          :options="yearGaleria"
          v-model="filter.year"
          label="year"
          placeholder="Años"
          class="vue-select"
          :clearable="false"
        >
        </v-select>
      </div>
    </div>

    <div 
      class="row over-y mb-4"
      :style="`height: ${heightWindow}`"
    >
      
      <div class="col-12">
        <Loading 
          v-if="loadingGaleria"
          pixeles="200px"
        />
        <AlbumesList 
          :data="galeriasMesYear"
          v-if="!loadingGaleria"
        />
      </div>
    </div>
  </section>

</template>